interface NoAssigneeIconProps {
  size?: number;
}

const NoAssigneeIcon = ({ size = 20 }: NoAssigneeIconProps) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      clipPath="url(#a)"
      stroke="#737373"
      strokeWidth="1.5"
    >
      <circle
        cx="9.999"
        cy="10"
        r="9"
        strokeDasharray="2 3"
        strokeLinecap="round"
        transform="rotate(59.844 10 10)"
      />
      <path
        d="M15.25 17.5v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3v2.026M13 6.25a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect
          fill="#fff"
          height="20"
          rx="10"
          width="20"
        />
      </clipPath>
    </defs>
  </svg>
);

export default NoAssigneeIcon;
